import React from 'react';
import { Outlet } from 'react-router-dom';

const ItemsLayout = () => {
  return (
    <div className="container-fluid mb-4 px-0 tab-navigasi">
      <div className="w-100 pb-3 pb-lg-4 mb-3 mb-lg-4 border-bottom border-lg-0">
        <div className="w-100 swiper-nav swiper">
          <div className="swiper-button-next"></div>
          <div className="swiper-button-prev"></div>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default ItemsLayout;
